import React from 'react';

interface FieldSkeletonProps {
  className?: string;
}

const FieldSkeleton: React.FC<FieldSkeletonProps> = () => (
  <div className="space-y-2">
    <div className="h-[12px] w-24 bg-gray-200 rounded-full animate-pulse" />
    <div
      className="h-[32px] w-full bg-gray-100 rounded animate-pulse border border-[#D4D4D4]"
      style={{ minHeight: '32px' }}
    />
  </div>
);

interface FormSectionSkeletonProps {
  fields: number;
  spacing?: number;
  className?: string;
}

const FormSectionSkeleton: React.FC<FormSectionSkeletonProps> = ({
  fields,
  spacing = 4,
  className = '',
}) => {
  const gapClass = spacing === 3 ? 'gap-3' : 'gap-4';

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${gapClass} ${className}`}>
      {Array.from({ length: fields }).map((_, i) => (
        <FieldSkeleton key={i} />
      ))}
    </div>
  );
};

interface FormSkeletonProps {
  sections?: { fields: number; spacing?: number }[];
  showButton?: boolean;
  className?: string;
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({
  sections = [{ fields: 4 }],
  showButton = true,
  className = '',
}) => {
  return (
    <div className={className}>
      {sections.map((section, index) => (
        <FormSectionSkeleton
          key={index}
          fields={section.fields}
          spacing={section.spacing}
          className={index > 0 ? 'mt-6' : ''}
        />
      ))}
      {showButton && (
        <div className="flex items-center gap-3 mt-6">
          <div className="h-9 w-24 bg-gray-200 rounded animate-pulse" />
          <div className="h-9 w-28 bg-gray-200 rounded animate-pulse" />
        </div>
      )}
    </div>
  );
};

export { FormSkeleton, FormSectionSkeleton, FieldSkeleton };
export default FormSkeleton;
